import { createContext, useContext } from 'react'

type RcaInsuranceValues = {
  isEditable: boolean
  isCalculatingLoading: boolean
  handleCalculate: (onSuccess: () => void) => Promise<void>
  handleRecalculate: () => void
}

const RcaInsuranceContext = createContext<RcaInsuranceValues>({
  isEditable: false,
  isCalculatingLoading: false,
  handleCalculate: () => Promise.resolve(),
  handleRecalculate: () => null
})

export const RcaInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<RcaInsuranceValues>) => {
  return (
    <RcaInsuranceContext.Provider value={values}>
      {children}
    </RcaInsuranceContext.Provider>
  )
}

export const useRcaInsuranceValues = () => useContext(RcaInsuranceContext)
